import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import CustomerAdministrator from './customer-administrator-model'
import {
  CreateCustomerAdministratorAsync,
  DeleteCustomerAdministratorAsync,
  LoadCustomerAdministratorsAsync,
} from './customerAdministrator-thunk'
const initialState: customerAdministratorSliceState = {
  customerAdministrator: [],
  selected_customerAdministrator: '',
  is_loading_customerAdministrator: false,
  is_creating_customerAdministrator: false,
  is_deleting_customerAdministrator: false,
}
export interface customerAdministratorSliceState {
  customerAdministrator: CustomerAdministrator[]
  selected_customerAdministrator?: string
  is_loading_customerAdministrator: boolean
  is_creating_customerAdministrator: boolean
  is_deleting_customerAdministrator: boolean
}
export const customerAdministratorSlice = createSlice({
  name: 'customerAdministrator',
  initialState,
  reducers: {
    setSelectedcustomerAdministrator: (state, action) => {
      state.selected_customerAdministrator = action.payload
    },
    clearStatecustomerAdministrator: (state) => {
      state.customerAdministrator = []
      state.is_loading_customerAdministrator = false
      state.is_creating_customerAdministrator = false
      state.is_deleting_customerAdministrator = false
    },
    mergecustomerAdministrator: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_customerAdministrator = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.customerAdministrator = merge(
            state.customerAdministrator,
            payload,
          ) as any
        }
      }
    },

    add_customerAdministrator: (state, action) => {
      if (action.payload) {
        state.customerAdministrator = [
          ...state.customerAdministrator,
          action.payload,
        ]
      }
    },
    set_customerAdministrator: (state, action) => {
      let { key, value, id } = action.payload
      state.customerAdministrator = state.customerAdministrator.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCustomerAdministratorsAsync.pending, (state) => {
      state.is_loading_customerAdministrator = true
    })
    builder.addCase(
      LoadCustomerAdministratorsAsync.fulfilled,
      (state, action) => {
        state.is_loading_customerAdministrator = false
        if (action.payload) {
          state.customerAdministrator = action.payload
        }
      },
    )
    builder.addCase(LoadCustomerAdministratorsAsync.rejected, (state) => {
      state.is_loading_customerAdministrator = false
    })
    builder.addCase(CreateCustomerAdministratorAsync.pending, (state) => {
      state.is_creating_customerAdministrator = true
    })
    builder.addCase(CreateCustomerAdministratorAsync.fulfilled, (state) => {
      state.is_creating_customerAdministrator = false
    })
    builder.addCase(CreateCustomerAdministratorAsync.rejected, (state) => {
      state.is_creating_customerAdministrator = false
    })
    builder.addCase(DeleteCustomerAdministratorAsync.pending, (state) => {
      state.is_deleting_customerAdministrator = true
    })
    builder.addCase(
      DeleteCustomerAdministratorAsync.fulfilled,
      (state, action) => {
        state.is_deleting_customerAdministrator = false
        if (state.customerAdministrator) {
          state.customerAdministrator = state.customerAdministrator.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteCustomerAdministratorAsync.rejected, (state) => {
      state.is_deleting_customerAdministrator = false
    })

    builder.addCase(autoThunks.init_customer_administrator.pending, (state) => {
      state.is_loading_customerAdministrator = true
    })
    builder.addCase(
      autoThunks.init_customer_administrator.fulfilled,
      (state, action) => {
        state.is_loading_customerAdministrator = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.init_customer_administrator.rejected,
      (state) => {
        state.is_loading_customerAdministrator = false
      },
    )

    builder.addCase(
      autoThunks.get_customer_administrator_as_customer.pending,
      (state) => {
        state.is_loading_customerAdministrator = true
      },
    )
    builder.addCase(
      autoThunks.get_customer_administrator_as_customer.fulfilled,
      (state, action) => {
        state.is_loading_customerAdministrator = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_customer_administrator_as_customer.rejected,
      (state) => {
        state.is_loading_customerAdministrator = false
      },
    )
  },
})

function handleResult(action: any, state: customerAdministratorSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_customerAdministrator = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.customerAdministrator = merge(
        state.customerAdministrator,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatecustomerAdministrator,
  setSelectedcustomerAdministrator,
  set_customerAdministrator,
  mergecustomerAdministrator,
  add_customerAdministrator,
} = customerAdministratorSlice.actions

export const get_customerAdministrator =
  (id?: string) =>
  (state: {
    customerAdministrator: {
      customerAdministrator: CustomerAdministrator[]
    }
  }): CustomerAdministrator | null => {
    let temp = state?.customerAdministrator?.customerAdministrator?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.customerAdministrator?.customerAdministrator[0] || null
  }
export const get_selected_customerAdministrator = (state: {
  customerAdministrator: customerAdministratorSliceState
}): CustomerAdministrator | null => {
  let id = state?.customerAdministrator?.selected_customerAdministrator
  let temp = state?.customerAdministrator?.customerAdministrator?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_customerAdministrator = (state: {
  customerAdministrator: {
    customerAdministrator: CustomerAdministrator[]
  }
}): CustomerAdministrator[] => {
  let temp = state?.customerAdministrator?.customerAdministrator
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_customerAdministrator_busy = (state: {
  customerAdministrator: customerAdministratorSliceState
}) => {
  return (
    state?.customerAdministrator.is_deleting_customerAdministrator ||
    state?.customerAdministrator.is_loading_customerAdministrator ||
    state?.customerAdministrator.is_creating_customerAdministrator
  )
}
export const is_deleting_customerAdministrator_busy = (state: {
  customerAdministrator: customerAdministratorSliceState
}) => {
  return state?.customerAdministrator.is_deleting_customerAdministrator
}
export const is_loading_customerAdministrator_busy = (state: {
  customerAdministrator: customerAdministratorSliceState
}) => {
  return state?.customerAdministrator.is_loading_customerAdministrator
}
export const is_creating_customerAdministrator_busy = (state: {
  customerAdministrator: customerAdministratorSliceState
}) => {
  return state?.customerAdministrator.is_creating_customerAdministrator
}

export default customerAdministratorSlice.reducer
